import { SiteAddress } from '../../tabs/card/SiteAddress';
import { MissionWindowCoa } from './MissionWindowCoa';
import { classes, extend, media, stylesheet } from 'typestyle';
import {
  Gray100,
  typeCompact14RegularProperties,
  typeCompact17MediumProperties,
  typeCompact20DisplayProperties,
} from '@traceair/tds';
import { useAppStore } from '../../../../../store/appStore';
import { BREAKPOINT_SMALL } from '../../../../layout/styles';
import { MissionWindowDate } from './MissionWindowDate';
import { MissionWindowWinterConditions } from './MissionWindowWinterConditions';

const css = stylesheet({
  container: extend(
    {
      display: 'flex',
      justifyContent: 'space-between',
      gap: 32,
      marginBottom: 22,
    },
    media(
      { maxWidth: BREAKPOINT_SMALL },
      {
        flexDirection: 'column',
        gap: 16,
        marginBottom: 16,
      },
    ),
  ),
  containerWithDate: extend(
    {
      $nest: {
        '&&': {
          marginBottom: 18,
        },
      },
    },
    media(
      { maxWidth: BREAKPOINT_SMALL },
      {
        $nest: {
          '&&': {
            marginBottom: 16,
          },
        },
      },
    ),
  ),
  siteInfo: {
    flex: '1 1 auto',
  },
  siteName: extend(
    {
      margin: '0 0 4px',
      ...typeCompact20DisplayProperties,
    },
    media(
      {
        maxWidth: BREAKPOINT_SMALL,
      },
      {
        ...typeCompact17MediumProperties,
      },
    ),
  ),
  customerName: extend({
    margin: '0 0 4px',
    color: Gray100,
    ...typeCompact14RegularProperties,
  }),
  address: {
    margin: '4px 0 0',
    ...typeCompact14RegularProperties,
  },
});

export const MissionWindowPrimaryInfo = () => {
  const { selectedMission } = useAppStore();
  if (!selectedMission) return null;

  const { schedule, gcpPlacementService } = selectedMission;
  const hasScheduleOrGcpPlacement = !!schedule || !!gcpPlacementService;

  return (
    <div>
      <div className={classes(css.container, hasScheduleOrGcpPlacement && css.containerWithDate)}>
        <div className={css.siteInfo}>
          <h1 className={css.siteName}>{selectedMission.site.name}</h1>
          <h2 className={css.customerName}>{selectedMission.customer.name}</h2>

          {selectedMission.site.projectInfo.siteAddress && (
            <div className={css.address}>
              <SiteAddress site={selectedMission.site} inOpenMission />
            </div>
          )}

          <MissionWindowDate />
        </div>

        <MissionWindowCoa airtableProjectId={selectedMission.site.projectInfo.airtableRecordId} />
      </div>

      <MissionWindowWinterConditions />
    </div>
  );
};
